module.exports = __webpack_public_path__ + "static/media/70Hou.fe094340.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/70Hou.png
// module id = 1684
// module chunks = 0 1